import React from "react";

interface SkeletonLoaderProps {
  variant: "basic" | "card";
  count: number;
  sectionTitle: string;
}

const BasicSkeleton: React.FC<{ index: number; sectionTitle: string }> = ({
  index,
  sectionTitle,
}) => (
  <div
    key={`skeleton-${sectionTitle}-${index}`}
    className="not-prose w-fit py-2 px-5 rounded-full bg-white animate-pulse"
  >
    <div className="h-6 w-24 bg-gray-200 rounded"></div>
  </div>
);

const CardSkeleton: React.FC<{ index: number; sectionTitle: string }> = ({
  index,
  sectionTitle,
}) => (
  <div
    key={`skeleton-${sectionTitle}-${index}`}
    className="not-prose flex flex-col p-6 rounded-xl bg-white shadow-xl w-full md:flex-1 md:min-w-0 animate-pulse"
  >
    <div className="flex justify-center items-center p-1 mb-2">
      <div className="h-5 w-5 bg-gray-200 rounded"></div>
    </div>
    <div className="h-6 w-20 bg-gray-200 rounded mb-2"></div>
    <div className="h-4 w-full bg-gray-200 rounded"></div>
  </div>
);

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  variant,
  count,
  sectionTitle,
}) => {
  const SkeletonComponent = variant === "basic" ? BasicSkeleton : CardSkeleton;

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonComponent
          key={`skeleton-${sectionTitle}-${index}`}
          index={index}
          sectionTitle={sectionTitle}
        />
      ))}
    </>
  );
};
